import { render, staticRenderFns } from "./AttachmentsBlock3.vue?vue&type=template&id=0dc5cd19"
import script from "./AttachmentsBlock3.vue?vue&type=script&lang=js"
export * from "./AttachmentsBlock3.vue?vue&type=script&lang=js"
import style0 from "../attachments-shared.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports